/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LabOrderPatientClinic } from './LabOrderPatientClinic';

export type LabOrderPatient = {
    readonly id?: number;
    first_name: string;
    last_name?: string | null;
    date_of_birth?: string | null;
    readonly clinic?: LabOrderPatientClinic;
    /**
     * HL7 single character representation of sex: F, M, O, U, A
     */
    sex?: LabOrderPatient.sex | null;
}

export namespace LabOrderPatient {

    /**
     * HL7 single character representation of sex: F, M, O, U, A
     */
    export enum sex {
        M = 'M',
        F = 'F',
        O = 'O',
        U = 'U',
        A = 'A',
    }


}
